module.exports = __webpack_public_path__ + "img/loads-7.396a90ad.jpg";